export default __webpack_public_path__ + "static/media/HAB2.883393da.webp";